import React, { Component } from 'react';
import {
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    FormControlLabel,
    Radio,
    RadioGroup,
    withStyles
} from '@material-ui/core';

const styles = theme => ({
    modalContent: {
        minHeight: 400,
    },
    filterField: {
        marginBottom: theme.spacing(2),
    },
});

class RespondServicosModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filtroServicos: '',
            itemSelecionado: null,
            mostrarDetalhesItem: false,
            quantidade: 1,
            precoSelecionado: '1'
        };
    }

    handleFiltroChange = (event) => {
        this.setState({ filtroServicos: event.target.value });
    };

    getServicosFiltrados = () => {
        const { servicosCache } = this.props;
        const { filtroServicos } = this.state;

        if (!filtroServicos) return servicosCache;

        const termo = filtroServicos.toLowerCase();
        return servicosCache.filter(servico =>
            servico.nome.toLowerCase().includes(termo) ||
            (servico.descricao || '').toLowerCase().includes(termo) ||
            (servico.codigo_interno || '').toLowerCase().includes(termo)
        );
    };

    selecionarItem = (item) => {
        this.setState({
            itemSelecionado: item,
            mostrarDetalhesItem: true
        });
    };

    voltarParaLista = () => {
        this.setState({
            mostrarDetalhesItem: false,
            itemSelecionado: null
        });
    };

    adicionarItem = () => {
        const { onAdicionarItem, onFechar, currentLanguage } = this.props;
        const { itemSelecionado, quantidade, precoSelecionado } = this.state;

        if (!itemSelecionado) return;

        const qtd = parseInt(quantidade) || 1;
        const preco = precoSelecionado === '1' ? itemSelecionado.valor : itemSelecionado.valor_2;
        const valorTotalItem = preco * qtd;

        const novoItem = {
            id: itemSelecionado.id,
            texto: `${itemSelecionado.nome} - ${qtd}x ${itemSelecionado.tipo} - ${this.formatarMoeda(valorTotalItem)}`,
            valor: valorTotalItem
        };

        onAdicionarItem(novoItem);
        onFechar();
    };

    formatarMoeda = (valor) => {
        const { currentLanguage } = this.props;
        return new Intl.NumberFormat(currentLanguage.lang_code === 'en' ? 'en-US' : 'pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor || 0);
    };

    render() {
        const { classes, open, onFechar, servicosCache, currentLanguage } = this.props;
        const { mostrarDetalhesItem, itemSelecionado, filtroServicos, quantidade, precoSelecionado } = this.state;
        const servicosFiltrados = this.getServicosFiltrados();

        return (
            <Dialog
                open={open}
                onClose={onFechar}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {currentLanguage.bepiService.workshop.workshop_respond_item_details_title}
                </DialogTitle>

                <DialogContent className={classes.modalContent}>
                    {!mostrarDetalhesItem ? (
                        <Box>
                            <TextField
                                fullWidth
                                label={currentLanguage.bepiService.workshop.workshop_respond_filter_label}
                                value={filtroServicos}
                                onChange={this.handleFiltroChange}
                                className={classes.filterField}
                                placeholder={currentLanguage.bepiService.workshop.workshop_respond_filter_placeholder}
                            />

                            <List>
                                {servicosFiltrados.map(servico => (
                                    <ListItem
                                        key={servico.id}
                                        button
                                        onClick={() => this.selecionarItem(servico)}
                                    >
                                        <ListItemText
                                            primary={`${servico.codigo_interno} - ${servico.nome}`}
                                            secondary={`${servico.tipo} - ${servico.descricao}`}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    ) : (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {itemSelecionado?.nome} ({itemSelecionado?.tipo})
                            </Typography>

                            <TextField
                                fullWidth
                                label={currentLanguage.bepiService.workshop.workshop_respond_quantity_label}
                                type="number"
                                value={quantidade}
                                onChange={(e) => this.setState({ quantidade: e.target.value })}
                                inputProps={{ min: 1 }}
                                style={{ marginBottom: 16 }}
                            />

                            <RadioGroup
                                name="precoOption"
                                value={precoSelecionado}
                                onChange={(e) => this.setState({ precoSelecionado: e.target.value })}
                            >
                                <FormControlLabel
                                    value="1"
                                    control={<Radio />}
                                    label={`${currentLanguage.bepiService.shared.shared_resp_modal_price} 1: ${this.formatarMoeda(itemSelecionado?.valor)}`}
                                />
                                <FormControlLabel
                                    value="2"
                                    control={<Radio />}
                                    label={`${currentLanguage.bepiService.shared.shared_resp_modal_price} 2: ${this.formatarMoeda(itemSelecionado?.valor_2)}`}
                                />
                            </RadioGroup>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions>
                    {mostrarDetalhesItem ? (
                        <>
                            <Button onClick={this.voltarParaLista} color="secondary">
                                {currentLanguage.bepiService.shared.shared_details_cancel_btn}
                            </Button>
                            <Button onClick={this.adicionarItem} color="primary" variant="contained">
                                {currentLanguage.bepiService.workshop.workshop_respond_add_btn}
                            </Button>
                        </>
                    ) : (
                        <Button onClick={onFechar} color="primary">
                            {currentLanguage.bepiService.shared.shared_equip_form_close_btn}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(RespondServicosModal);
